import React from "react";

import { TextField, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

interface NotifyEmailCommentProps {
  note: string;
  setNote: (note: string) => void;
  SubmitButton: React.ComponentType;
}

const NotifyEmailComment = ({
  note,
  setNote,
  SubmitButton,
}: NotifyEmailCommentProps) => {
  const { t } = useTranslation("bulletin/share");

  return (
    <>
      <label htmlFor="note-editor" style={{ color: "gray" }}>
        {t("message")}
      </label>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          id="note-editor"
          multiline
          rows={6}
          fullWidth
          variant="outlined"
          color="secondary"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={t("message")}
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <SubmitButton />
        </Box>
      </Box>
    </>
  );
};

export default NotifyEmailComment;
